var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-login-box"},[(_vm.MLoginOpen)?_c('MLogin',{attrs:{"isDialog":_vm.isDialog,"allowCloseDialog":true,"dialogTitle":_vm.dialogTitle,"redirectUri":_vm.redirectUri,"targetType":_vm.isRegister ? 'register' : 'login',"actionData":{
      actionPosition: 'official_website',
      actionDetail: _vm.actionDetail,
    },"disableOptions":{
      thirdPartLogin: !_vm.showThirdParty,
      google: true,
    }},on:{"close":_vm.closeHandle,"setUserInfo":_vm.setUserInfoHandle,"turnPage":_vm.turnPageHandle}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }